import {FormControl} from '@angular/forms';
import {IDropdownObject} from './dropdown-object.interface';
import {IMessengers} from './messengers.interface';

export interface IGeneralRecruiter {
  name: null | string;
  surname: null | string;
  department: null | IDropdownObject;
  level: null | IDropdownObject;
  pm: null | IDropdownObject;
  hr: null | IDropdownObject;
  os: null | IDropdownObject;
  unit: null | IDropdownObject;
  lineManager: null | IDropdownObject;
  startDate: null | string;
  commentFromRecruiter: null | string;
  employmentForm: null | IDropdownObject;
  position: null | IDropdownObject;
  anukoLogin: null | string;
  contractorWorkingHoursPerWeek: null | number;
  firstProject: null | string;
  pe: null | IDropdownObject;
  subDepartment?: null | IDropdownObject;
  country: null | IDropdownObject;
  city: null | string;
  phoneNumbers: IMessengers[];
  file: null | File;
  interviews: number[];
}

export interface ISalaryRecruiter {
  salary: null | number;
  ratePerHour: null | number;
  comment: null | string;
  dataFile: null | File;
  employeeId: number | null;
}

export interface ISalaryRecruiterEdit extends ISalaryRecruiter {
  id: number | null;
  date: string | null;
}

export interface IEmployeeUniqueness {
  firstName: string;
  lastName: string;
}

export type SalaryRecruiterFormGroup<T> = {
  [field in keyof T]: FormControl<T[field]>;
};

export enum EmploymentFormStatus {
  ContractorFT,
  ContractorPT,
  Employee,
  Consultant,
  Former,
}
